import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import Button from "../../../../UI/Buttons/Button";

//styles
import { useStyles } from "./styles";

interface IDeleteFlatFee {
  onAccept: () => void;
  setToggleModal: (state: boolean) => void;
	data: any;
}

const DeleteFlatFee: React.FC<IDeleteFlatFee> = ({ onAccept, setToggleModal, data }): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" className={styles.title}>
        {t("admin.flatFee.accept_delete.title").replace('{flatFeeId}', `${data.id}`)}
      </Typography>

      {
        data.payment_status === "withPayment" && (
          <Typography className={styles.description} variant="body2">
            {t("admin.flatFee.accept_delete.description")}
          </Typography>
        )
      }

      <Box className={styles.footer}>
        <Button
          gradient
          className={styles.buttonDelete}
          type="submit"
          variant="contained"
          onClick={onAccept}
        >
          {t("common.buttons.annul")}
        </Button>
        <Button
          className={styles.button}
          type="button"
          variant="outlined"
          color="secondary"
          onClick={() => setToggleModal(false)}
        >{t("common.buttons.cancel")}</Button>
      </Box>
    </Box>
  );
};

export default DeleteFlatFee;
